import type { WorkItem } from '@/types/content';

export const workItems: WorkItem[] = [
  {
    id: 'frieren',
    title: '葬送的芙莉莲',
    originalTitle: '葬送のフリーレン',
    type: '动画',
    region: '日本',
    year: 2023,
    status: '连载中（第二季制作中）',
    studio: 'Madhouse',
    creator: '原作：山田钟人 / 作画：阿部司',
    episodes: '28 话 + 第二季',
    score: 9.4,
    popularity: 9820,
    updatedAt: '2026-10-15',
    intro:
      '勇者一行打倒魔王之后，寿命漫长的精灵魔法使芙莉莲重新踏上旅途，去理解那些曾经被她忽略的人类情感。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20illustration%20of%20a%20white%20haired%20elf%20mage%20holding%20a%20wooden%20staff%2C%20gentle%20smile%2C%20flowing%20cape%2C%20soft%20teal%20mist%20background%20with%20warm%20amber%20light%20particles%2C%20painterly%20digital%20art%2C%20elegant%20vertical%20poster%20composition%2C%20simple%20clean%20backdrop&width=600&height=800&seq=work-poster-frieren&orientation=portrait',
    tags: ['奇幻', '公路片', '治愈'],
    quote: '把“之后”的故事，讲成一首很长很轻的诗。',
    content: [
      '故事从魔王被击败的那一年开始。勇者一行各自散去，精灵魔法使芙莉莲回到独自一人的旅途。五十年后，当她再次见到昔日的同伴时，才发现自己从未真正理解过“人类的时间”。',
      '作品最动人的地方在于它并不急于制造冲突。大量篇幅留给沿途的小事：一次教学、一顿饭、一座被遗忘的雕像。正是这些不起眼的瞬间，让芙莉莲逐渐学会为别人停留。',
      '动画版以稳定的作画与克制的情感表达获得广泛好评，配乐在旅途场景中的留白处理尤其出色，被认为是近年奇幻改编的标杆之一。',
    ],
  },
  {
    id: 'dungeon-meshi',
    title: '迷宫饭',
    originalTitle: 'ダンジョン飯',
    type: '漫画',
    region: '日本',
    year: 2016,
    status: '已完结（全 14 卷）',
    studio: 'KADOKAWA / Harta',
    creator: '九井谅子',
    episodes: '全 97 话',
    score: 9.2,
    popularity: 8640,
    updatedAt: '2026-10-09',
    intro:
      '为了救回被龙吞下的妹妹，一支穷困的冒险队伍决定在迷宫里就地取材，把魔物做成料理。',
    content: [
      '这是一部把“迷宫生态”当成真正课题来做的奇幻漫画。作者为每一种魔物设计了完整的食物链、栖息地与解剖结构，再把它们一道道端上餐桌。',
      '看似搞笑的设定之下，是对“吃”这件事极其认真的讨论：吃什么、和谁吃、为什么吃。当故事逐渐逼近迷宫的核心，那些关于饥饿与欲望的伏笔才一一浮出水面。',
      '作者的分镜干净利落，料理过程画得极具说服力。即便完全不懂奇幻设定，也能从每一顿饭里读出角色的性格。',
    ],
    quote: '“迷宫里的一切都可以吃，问题只在于你敢不敢。”',
    tags: ['奇幻', '美食', '冒险'],
  },
  {
    id: 'suzume',
    title: '铃芽之旅',
    originalTitle: 'すずめの戸締まり',
    type: '动画',
    region: '日本',
    year: 2022,
    status: '已完结（剧场版）',
    studio: 'CoMix Wave Films',
    creator: '新海诚',
    episodes: '剧场版 122 分钟',
    score: 8.7,
    popularity: 9120,
    updatedAt: '2026-09-18',
    intro:
      '少女铃芽在九州遇见寻找“门”的青年，随后踏上一段横跨日本的关闭灾厄之门之旅。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20style%20vertical%20poster%20illustration%20of%20a%20teenage%20girl%20standing%20on%20a%20coastal%20road%20with%20a%20small%20wooden%20chair%2C%20dramatic%20sky%20with%20teal%20clouds%20and%20warm%20sunset%2C%20wind%20blowing%20hair%2C%20painterly%20digital%20art%2C%20cinematic%20depth%2C%20clean%20simple%20background&width=600&height=800&seq=work-poster-suzume&orientation=portrait',
    tags: ['剧场版', '公路片', '灾难'],
    quote: '“门的那一边，是我们不愿再想起的地方。”',
    content: [
      '影片以九州港口小镇为起点，少女铃芽偶然遇见正在寻找废屋之门的青年草太。她推开门的一瞬间，看见了那片被称为“常世”的星空。',
      '随着门的开启，灾厄从日本各地的废墟中涌出。两人带着一把会说话的小椅子，从九州一路北上到宫城，关闭一扇又一扇门。',
      '新海诚在这部作品里把“灾难记忆”放到了前台。废墟不是背景，而是需要被认真告别的地方。这一点让影片比导演此前的作品更沉，也更诚恳。',
    ],
  },
  {
    id: 'gits-sac',
    title: '攻壳机动队 SAC_2045',
    originalTitle: '攻殻機動隊 SAC_2045',
    type: '动画',
    region: '日本',
    year: 2020,
    status: '已完结（两季）',
    studio: 'Production I.G × SOLA DIGITAL ARTS',
    creator: '原作：士郎正宗',
    episodes: '全 24 话',
    score: 8.1,
    popularity: 6980,
    updatedAt: '2026-08-22',
    intro:
      '在“可持续战争”之后的世界，公安九课再次集结，追查被称为“后人类”的新型威胁。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20style%20vertical%20poster%20illustration%20of%20a%20cyborg%20agent%20in%20a%20long%20coat%20standing%20in%20a%20rainy%20futuristic%20city%2C%20holographic%20signs%2C%20deep%20teal%20tones%20with%20amber%20highlights%2C%20painterly%20digital%20art%2C%20moody%20cinematic%20vertical%20composition&width=600&height=800&seq=work-poster-gits&orientation=portrait',
    tags: ['科幻', '赛博朋克', '政治'],
    quote: '“当身体可以被替换，什么才算是人？”',
    content: [
      '2045 年的世界被“可持续战争”撕成碎片，经济体系围绕战争本身运转。公安九课以雇佣兵身份重新集结，随后被卷入一场关于“后人类”的事件。',
      '本作采用全 3DCG 制作，视觉风格与前作差异明显，也因此在上线时引发了不少讨论。但剧作层面依旧延续了《攻壳》系列对政治、身体与网络意识的追问。',
      '如果你第一次接触这个系列，可以从本作入门，再回头看重制版《SAC》。两者在议题上一脉相承，只是提问的方式不同。',
    ],
  },
  {
    id: 'blue-lock',
    title: '蓝色监狱',
    originalTitle: 'ブルーロック',
    type: '漫画',
    region: '日本',
    year: 2018,
    status: '连载中',
    studio: '讲谈社 / 周刊少年Magazine',
    creator: '原作：金城宗幸 / 作画：野村优介',
    episodes: '连载中，已出版 30+ 卷',
    score: 8.4,
    popularity: 8460,
    updatedAt: '2026-09-30',
    intro:
      '日本足球为了夺得世界杯，启动了一场极端的 striker 培养计划——三百名前锋，只有一人能活到最后。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20style%20vertical%20poster%20illustration%20of%20a%20determined%20young%20football%20striker%20in%20a%20blue%20jersey%20striking%20a%20ball%2C%20stadium%20floodlights%2C%20teal%20and%20amber%20lighting%2C%20dynamic%20action%20pose%2C%20painterly%20digital%20art%2C%20clean%20graphic%20background&width=600&height=800&seq=work-poster-bluelock&orientation=portrait',
    tags: ['运动', '足球', '热血'],
    quote: '“前锋不需要配合，前锋只需要进球。”',
    content: [
      '故事主角洁世一是一名技术细腻却缺乏“自私”的前锋。被选入蓝色监狱计划后，他必须在极度竞争的环境中重新定义自己的踢法。',
      '作品的爽感来自极其夸张的心理描写：每一次触球都伴随着大段内心独白与空间想象，把足球场画成了战场。这种处理方式褒贬分明，但确实让读者记住了每个角色的“自我”。',
      '漫画的作画在比赛场景中极具张力，分镜常以斜切与特写打断节奏，制造出强烈的压迫感。',
    ],
  },
  {
    id: 'tengoku-daimakyo',
    title: '天国大魔境',
    originalTitle: '天国大魔境',
    type: '动画',
    region: '日本',
    year: 2023,
    status: '已完结（第一季）',
    studio: 'Production I.G',
    creator: '原作：石黑正数',
    episodes: '全 13 话',
    score: 8.9,
    popularity: 7340,
    updatedAt: '2026-07-14',
    intro:
      '文明崩塌后的日本，少年少女在围墙内生活；墙外，两人踏上寻找“天国”的旅程。两条线索逐渐交汇。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20style%20vertical%20poster%20illustration%20of%20two%20teenagers%20standing%20at%20the%20edge%20of%20a%20ruined%20futuristic%20facility%20overgrown%20with%20grass%2C%20huge%20teal%20sky%20with%20soft%20clouds%2C%20warm%20sunlight%2C%20painterly%20digital%20art%2C%20mysterious%20vertical%20composition&width=600&height=800&seq=work-poster-tengoku&orientation=portrait',
    tags: ['科幻', '悬疑', '末世'],
    quote: '“墙内是乐园，墙外才是世界。”',
    content: [
      '作品采用双线叙事。一边是围墙内被悉心照料的孩子们，另一边是废墟日本中旅行的少年少女。两条线看似无关，却在细节上不断互相照应。',
      '石黑正数擅长把恐怖藏在日常里：一顿饭、一次体检、一句无心的提问，都可能是伏笔。动画版对节奏做了压缩，但保留了原作最关键的信息密度。',
      '这是一部需要耐心、也值得反复观看的作品。第一次看是悬疑，第二次看是悲剧。',
    ],
  },
  {
    id: 'link-click',
    title: '时光代理人',
    originalTitle: '时光代理人',
    type: '动画',
    region: '中国',
    year: 2021,
    status: '连载中（第三季制作中）',
    studio: '澜映画 / bilibili',
    creator: '导演：李豪凌',
    episodes: '两季 + 特别篇',
    score: 8.6,
    popularity: 8020,
    updatedAt: '2026-09-12',
    intro:
      '两个拥有特殊能力的年轻人经营着一家“时光照相馆”，可以进入照片中的那一刻，替委托人完成未了的心愿。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20style%20vertical%20poster%20illustration%20of%20two%20young%20men%20inside%20a%20glowing%20photo%20studio%20with%20floating%20photographs%2C%20teal%20light%20beams%20and%20warm%20amber%20accents%2C%20time%20travel%20motifs%2C%20painterly%20digital%20art%2C%20cinematic%20vertical%20composition&width=600&height=800&seq=work-poster-linkclick&orientation=portrait',
    tags: ['国产动画', '悬疑', '时间'],
    quote: '“照片不会说谎，但拍照的人会。”',
    content: [
      '程小时可以进入照片，陆光能预知照片拍摄后的十二小时。两人以“时光照相馆”为名，接受各种委托，条件是不能改变过去的关键节点。',
      '作品把单元剧与主线悬疑结合得相当紧密。每一张照片都是一个独立的小故事，而这些故事又不断向同一条暗线靠拢。',
      '第一季在国内与海外平台都取得了不错的口碑，尤其以情绪浓度高、节奏紧凑著称。第三季目前处于制作阶段。',
    ],
  },
  {
    id: 'edgerunners',
    title: '赛博朋克：边缘行者',
    originalTitle: 'Cyberpunk: Edgerunners',
    type: '动画',
    region: '日本',
    year: 2022,
    status: '已完结（10 话）',
    studio: 'Trigger',
    creator: '原作：CD Projekt Red',
    episodes: '全 10 话',
    score: 9.0,
    popularity: 9540,
    updatedAt: '2026-09-30',
    intro:
      '在夜之城，一个失去一切的少年选择成为“边缘行者”，用身体换取速度、金钱与一点点自由。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20style%20vertical%20poster%20illustration%20of%20a%20boy%20with%20glowing%20cybernetic%20implants%20in%20a%20neon%20night%20city%2C%20chrome%20jacket%2C%20deep%20teal%20and%20hot%20amber%20light%2C%20rain%20streaks%2C%20painterly%20digital%20art%2C%20dramatic%20vertical%20poster%20composition&width=600&height=800&seq=work-poster-edgerunners&orientation=portrait',
    tags: ['赛博朋克', '科幻', '悲剧'],
    quote: '“在夜之城，没有人能成为传奇，除非他先烧掉自己。”',
    content: [
      'Trigger 与 CD Projekt Red 合作的十集短篇动画。少年大卫在母亲去世后装上军用义体，进入夜之城的雇佣兵世界。',
      '作品最狠的地方在于它从不许诺救赎。每一次升级都让他离“成为别人”更近一步，也让身边的人一个个离开。最后一集的处理几乎是残酷的干净。',
      '高饱和的色彩、极快的剪辑与强烈的音乐共同构成了一种近乎过载的观感。看完之后需要一点时间才能缓过来。',
    ],
  },
  {
    id: 'fog-hill',
    title: '雾山五行',
    originalTitle: '雾山五行',
    type: '动画',
    region: '中国',
    year: 2020,
    status: '连载中（新篇制作中）',
    studio: '六道无鱼动画工作室',
    creator: '导演：林魂',
    episodes: '已播出 6 话',
    score: 8.8,
    popularity: 7880,
    updatedAt: '2026-08-05',
    intro:
      '以水墨与写意笔法构建的奇幻世界，五行之力与妖兽的争斗在极简却极具张力的画面中展开。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20style%20vertical%20poster%20illustration%20of%20a%20warrior%20in%20flowing%20ink%20brush%20robes%20standing%20on%20a%20cliff%2C%20swirling%20ink%20wash%20clouds%20in%20teal%20and%20gold%2C%20traditional%20Chinese%20painting%20influence%2C%20painterly%20digital%20art%2C%20dramatic%20vertical%20composition&width=600&height=800&seq=work-poster-foghills&orientation=portrait',
    tags: ['国产动画', '水墨', '动作'],
    quote: '“一笔落下，山雾便有了形状。”',
    content: [
      '《雾山五行》最被称道的是动作场面。手绘作画配合水墨质感，让打斗既有重量又有流动感，很多镜头甚至能看到笔触的走向。',
      '故事本身并不复杂，围绕五行之力与妖兽的恩怨展开。真正吸引人的是它对“中式视觉语言”的探索——不依赖繁复设定，而用留白、墨色浓淡与构图传达情绪。',
      '制作团队规模很小，更新节奏也因此缓慢，但每一集都保持了极高的完成度。新篇目前正在制作中。',
    ],
  },
];